<app-modal [isOpen]="isOpen" (close)="onClose()" className="max-w-3xl mx-4 sm:mx-6">
  @if (chatflow; as cf) {
  <div class="p-6 sm:p-8">

    <!-- ══ Cabecera: identidad + estado + responsable ══════════════════════ -->
    <div class="mb-8 flex flex-col gap-4 sm:flex-row sm:items-start sm:gap-6">
      <div class="shrink-0">
        <div class="flex h-16 w-16 items-center justify-center rounded-2xl bg-brand-50 text-brand-600 dark:bg-brand-500/10 dark:text-brand-400">
          <span class="text-2xl font-semibold">{{ inicial }}</span>
        </div>
      </div>

      <div class="min-w-0 flex-1">
        <div class="flex flex-wrap items-center gap-2">
          <h2 class="text-2xl font-bold text-gray-900 dark:text-white">{{ cf.name }}</h2>
          <app-badge [color]="statusColor(cf.status)">{{ statusLabel(cf.status) }}</app-badge>
          <app-badge [color]="validationColor(cf.validationStatus)">{{ validationLabel(cf.validationStatus) }}</app-badge>
        </div>
        @if (cf.description) {
          <p class="mt-1 text-sm text-gray-600 dark:text-gray-400">{{ cf.description }}</p>
        }
      </div>

      <div class="flex flex-col items-start gap-1 sm:items-end">
        <span class="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">Responsable</span>
        <span class="text-sm font-medium text-gray-900 dark:text-white">{{ ownerName || 'Sin información' }}</span>
      </div>
    </div>

    <!-- Navegacion de pestanas: mismo patron que contacto-detail-modal. -->
    <div class="mb-6 border-b border-gray-200 dark:border-gray-700">
      <nav class="-mb-px flex gap-1">
        <button type="button" (click)="onTabChange('info')" data-test="tab-info"
          class="whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors"
          [class.border-brand-500]="activeTab === 'info'" [class.text-brand-600]="activeTab === 'info'"
          [class.dark:text-brand-400]="activeTab === 'info'" [class.border-transparent]="activeTab !== 'info'"
          [class.text-gray-500]="activeTab !== 'info'" [class.dark:text-gray-400]="activeTab !== 'info'">
          Información
        </button>
        <button type="button" (click)="onTabChange('analitica')" data-test="tab-analitica"
          class="whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors"
          [class.border-brand-500]="activeTab === 'analitica'" [class.text-brand-600]="activeTab === 'analitica'"
          [class.dark:text-brand-400]="activeTab === 'analitica'" [class.border-transparent]="activeTab !== 'analitica'"
          [class.text-gray-500]="activeTab !== 'analitica'" [class.dark:text-gray-400]="activeTab !== 'analitica'">
          Analítica
        </button>
        <button type="button" (click)="onTabChange('csat')" data-test="tab-csat"
          class="whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors"
          [class.border-brand-500]="activeTab === 'csat'" [class.text-brand-600]="activeTab === 'csat'"
          [class.dark:text-brand-400]="activeTab === 'csat'" [class.border-transparent]="activeTab !== 'csat'"
          [class.text-gray-500]="activeTab !== 'csat'" [class.dark:text-gray-400]="activeTab !== 'csat'">
          CSAT
        </button>
        <button type="button" (click)="onTabChange('versiones')" data-test="tab-versiones"
          class="whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors"
          [class.border-brand-500]="activeTab === 'versiones'" [class.text-brand-600]="activeTab === 'versiones'"
          [class.dark:text-brand-400]="activeTab === 'versiones'" [class.border-transparent]="activeTab !== 'versiones'"
          [class.text-gray-500]="activeTab !== 'versiones'" [class.dark:text-gray-400]="activeTab !== 'versiones'">
          Historial de versiones
        </button>
        <button type="button" (click)="onTabChange('comentarios')" data-test="tab-comentarios"
          class="whitespace-nowrap border-b-2 px-4 py-2.5 text-sm font-medium transition-colors"
          [class.border-brand-500]="activeTab === 'comentarios'" [class.text-brand-600]="activeTab === 'comentarios'"
          [class.dark:text-brand-400]="activeTab === 'comentarios'" [class.border-transparent]="activeTab !== 'comentarios'"
          [class.text-gray-500]="activeTab !== 'comentarios'" [class.dark:text-gray-400]="activeTab !== 'comentarios'">
          Comentarios ({{ comments.length }})
        </button>
      </nav>
    </div>

    @if (activeTab === 'info') {
    <div class="space-y-7">

      <!-- ══ Información general ═══════════════════════════════════════════ -->
      <section>
        <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Información general
        </h3>
        <dl class="grid grid-cols-1 gap-4 sm:grid-cols-2">
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Identificador técnico</dt>
            <dd class="mt-0.5 font-mono text-sm text-gray-800 dark:text-gray-200">{{ cf.identifier }}</dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">ID interno</dt>
            <dd class="mt-0.5 font-mono text-sm text-gray-800 dark:text-gray-200">{{ cf.id }}</dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Tipo de chatflow</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ typeLabel(cf.chatflowType) }}</dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Plantilla de origen</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ templateName }}</dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Prioridad</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">
              {{ priorityLabel(cf.priority) }} <span class="text-gray-400">({{ cf.priority }} · menor gana)</span>
            </dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Zona horaria de atención</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ zonaHoraria }}</dd>
          </div>
        </dl>
      </section>

      <!-- ══ Estado del chatflow ═══════════════════════════════════════════ -->
      <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
        <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Estado del chatflow
        </h3>
        <dl class="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Estado</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ statusLabel(cf.status) }}</dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Última publicación</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">
              {{ cf.publishedAt ? (cf.publishedAt | date:'dd/MM/yyyy HH:mm') : 'Nunca publicado' }}
            </dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Versión publicada</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ versionActual }}</dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Última validación</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">
              {{ cf.lastValidatedAt ? (cf.lastValidatedAt | date:'dd/MM/yyyy HH:mm') : 'Sin validar' }}
            </dd>
          </div>
        </dl>

        @if (cf.validationStatus === 'INVALID' && cf.validationErrors?.length) {
          <ul class="mt-3 space-y-1 rounded-lg bg-error-50 p-3 text-sm text-error-700 dark:bg-error-500/10 dark:text-error-400">
            @for (issue of cf.validationErrors; track $index) {
              <li>• @if (issue.nodeName || issue.nodeKey) {<span class="font-medium">[{{ issue.nodeName || issue.nodeKey }}]</span> }{{ issue.message }}</li>
            }
          </ul>
        }
      </section>

      <!-- ══ Métricas clave (últimos 30 días) ══════════════════════════════ -->
      <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
        <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Métricas clave <span class="font-normal normal-case tracking-normal text-gray-400">· últimos 30 días</span>
        </h3>
        @if (loadingRelated) {
          <p class="text-sm text-gray-400">Cargando métricas…</p>
        } @else if (hayMetricas && summary) {
          <dl class="grid grid-cols-1 gap-4 sm:grid-cols-4">
            <div>
              <dt class="text-xs text-gray-500 dark:text-gray-400">Conversaciones</dt>
              <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ summary.totalConversations }}</dd>
            </div>
            <div>
              <dt class="text-xs text-gray-500 dark:text-gray-400">Resueltas por el bot</dt>
              <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ porcentaje(summary.botCompletionRate) }}</dd>
            </div>
            <div>
              <dt class="text-xs text-gray-500 dark:text-gray-400">Derivadas a agente</dt>
              <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ porcentaje(summary.escalationRate) }}</dd>
            </div>
            <div>
              <dt class="text-xs text-gray-500 dark:text-gray-400">Tickets creados</dt>
              <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ summary.ticketsCreated }}</dd>
            </div>
          </dl>
        } @else {
          <p class="text-sm text-gray-400">Todavía no hay conversaciones en este periodo.</p>
        }
      </section>

      <!-- ══ Disponibilidad ════════════════════════════════════════════════ -->
      <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
        <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Disponibilidad
        </h3>
        @if (loadingRelated) {
          <p class="text-sm text-gray-400">Cargando disponibilidad…</p>
        } @else {
          <dl class="space-y-3">
            <div>
              <dt class="text-xs text-gray-500 dark:text-gray-400">Horario de atención</dt>
              <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ horarioResumen }}</dd>
            </div>
            <div class="grid grid-cols-1 gap-4 sm:grid-cols-2">
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Días festivos</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ feriadosResumen }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Fuera de horario</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ mensajeFueraDeHorario }}</dd>
              </div>
            </div>
          </dl>
        }
      </section>

      <!-- ══ Fecha y responsable ═══════════════════════════════════════════ -->
      <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
        <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
          Fecha y responsable
        </h3>
        <dl class="grid grid-cols-1 gap-4 sm:grid-cols-3">
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Fecha de creación</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ cf.datetimeCreated | date:'dd/MM/yyyy HH:mm' }}</dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Última actualización</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ cf.datetimeUpdated | date:'dd/MM/yyyy HH:mm' }}</dd>
          </div>
          <div>
            <dt class="text-xs text-gray-500 dark:text-gray-400">Creado por</dt>
            <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ ownerName || 'Sin información' }}</dd>
          </div>
        </dl>
        @if (cf.archivedAt) {
          <p class="mt-3 text-xs text-gray-400">Archivado el {{ cf.archivedAt | date:'dd/MM/yyyy HH:mm' }}.</p>
        }
      </section>
    </div>
    }

    <!-- Analitica: lectura del mismo periodo que las metricas clave. Los filtros por
         canal/equipo/agente estan en la pestana Analitica del editor. -->
    @if (activeTab === 'analitica') {
      @if (loadingAnalytics) {
        <p class="py-8 text-center text-sm text-gray-400">Cargando analítica…</p>
      } @else if (analyticsError) {
        <div class="rounded-xl border border-dashed border-gray-200 py-10 text-center dark:border-gray-700">
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ analyticsError }}</p>
        </div>
      } @else if (!hayAnalitica) {
        <div class="rounded-xl border border-dashed border-gray-200 py-10 text-center dark:border-gray-700">
          <p class="text-sm text-gray-500 dark:text-gray-400">Todavía no hay actividad en los últimos 30 días.</p>
          <p class="mt-1 text-xs text-gray-400">Cuando el chatflow reciba conversaciones, aquí verás su rendimiento.</p>
        </div>
      } @else {
      <div class="space-y-7" data-test="panel-analitica">

        <!-- ══ Resumen del periodo ═══════════════════════════════════════════ -->
        <section>
          <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Resumen <span class="font-normal normal-case tracking-normal text-gray-400">· últimos 30 días</span>
          </h3>
          @if (summary) {
            <dl class="grid grid-cols-2 gap-4 sm:grid-cols-4">
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Conversaciones</dt>
                <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ summary.totalConversations }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Resueltas por el bot</dt>
                <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ summary.botCompleted }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Derivadas a agente</dt>
                <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ summary.escalated }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Abandonadas</dt>
                <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ summary.abandoned }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Cerradas</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ summary.closed }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Expiradas esperando</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ summary.waitingTimeout }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Resueltas con la base de conocimiento</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ porcentaje(summary.knowledgeDeflectionRate) }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Tickets creados</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ summary.ticketsCreated }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">CSAT promedio</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ decimal(summary.csatAverage) }}</dd>
              </div>
            </dl>
          } @else {
            <p class="text-sm text-gray-400">Sin datos de resumen en este periodo.</p>
          }
        </section>

        <!-- ══ Rendimiento del bot ═══════════════════════════════════════════ -->
        <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
          <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Rendimiento del bot
          </h3>
          @if (botPerf) {
            <dl class="grid grid-cols-2 gap-4 sm:grid-cols-3">
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Finalizadas por el bot</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ botPerf.botCompleted }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Escaladas</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ botPerf.escalated }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Resueltas con conocimiento</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ botPerf.knowledgeDeflected }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Tasa de finalización</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ porcentaje(botPerf.botCompletionRate) }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Tasa de escalado</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ porcentaje(botPerf.escalationRate) }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Mensajes por conversación</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ decimal(botPerf.avgMessagesPerConversation) }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Duración media</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ duracion(botPerf.avgDurationSeconds) }}</dd>
              </div>
            </dl>
          } @else {
            <p class="text-sm text-gray-400">Sin datos del bot en este periodo.</p>
          }
        </section>

        <!-- ══ Cola de atención ══════════════════════════════════════════════ -->
        <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
          <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Cola de atención
          </h3>
          @if (queueStats) {
            <dl class="grid grid-cols-2 gap-4 sm:grid-cols-3">
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Entraron en cola</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ queueStats.totalQueued }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Asignadas desde la cola</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ queueStats.assignedFromQueue }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Expiradas en cola</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ queueStats.timedOutFromQueue }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Espera media</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ duracion(queueStats.avgQueueWaitSeconds) }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Espera máxima</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ duracion(queueStats.maxQueueWaitSeconds) }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Con respaldo aplicado</dt>
                <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ queueStats.fallbackTriggered }}</dd>
              </div>
            </dl>
          } @else {
            <p class="text-sm text-gray-400">Ninguna conversación pasó por la cola en este periodo.</p>
          }
        </section>

        <!-- ══ Pasos con más abandono ════════════════════════════════════════ -->
        <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
          <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Pasos con más abandono
          </h3>
          @if (nodosConMasAbandono.length > 0) {
            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-gray-200 text-left text-xs text-gray-500 dark:border-gray-700 dark:text-gray-400">
                    <th class="pb-2 pr-4 font-medium">Paso</th>
                    <th class="pb-2 pr-4 font-medium">Alcanzado</th>
                    <th class="pb-2 pr-4 font-medium">Abandono</th>
                    <th class="pb-2 pr-4 font-medium">Tiempo medio</th>
                    <th class="pb-2 font-medium">Conversión</th>
                  </tr>
                </thead>
                <tbody>
                  @for (nodo of nodosConMasAbandono; track nodo.nodeId) {
                    <tr class="border-b border-gray-100 last:border-0 dark:border-gray-800">
                      <td class="py-2 pr-4 text-gray-800 dark:text-gray-200">{{ nodo.nodeKey }}</td>
                      <td class="py-2 pr-4 text-gray-600 dark:text-gray-300">{{ nodo.reachedCount }}</td>
                      <td class="py-2 pr-4 text-gray-600 dark:text-gray-300">{{ nodo.dropoffCount }}</td>
                      <td class="py-2 pr-4 text-gray-600 dark:text-gray-300">{{ duracion(nodo.averageTimeOnNodeSeconds) }}</td>
                      <td class="py-2 text-gray-600 dark:text-gray-300">{{ porcentaje(nodo.conversionToNextPercent) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <p class="text-sm text-gray-400">Sin recorrido de pasos registrado en este periodo.</p>
          }
        </section>

        <!-- ══ Agentes ═══════════════════════════════════════════════════════ -->
        <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
          <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Agentes
          </h3>
          @if (agentesDestacados.length > 0) {
            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-gray-200 text-left text-xs text-gray-500 dark:border-gray-700 dark:text-gray-400">
                    <th class="pb-2 pr-4 font-medium">Agente</th>
                    <th class="pb-2 pr-4 font-medium">Atendidas</th>
                    <th class="pb-2 pr-4 font-medium">1.ª respuesta</th>
                    <th class="pb-2 pr-4 font-medium">Duración</th>
                    <th class="pb-2 font-medium">CSAT</th>
                  </tr>
                </thead>
                <tbody>
                  @for (agente of agentesDestacados; track agente.userId) {
                    <tr class="border-b border-gray-100 last:border-0 dark:border-gray-800">
                      <td class="py-2 pr-4 text-gray-800 dark:text-gray-200">{{ agente.userName }}</td>
                      <td class="py-2 pr-4 text-gray-600 dark:text-gray-300">{{ agente.conversationsHandled }}</td>
                      <td class="py-2 pr-4 text-gray-600 dark:text-gray-300">{{ duracion(agente.avgFirstResponseSeconds) }}</td>
                      <td class="py-2 pr-4 text-gray-600 dark:text-gray-300">{{ duracion(agente.avgDurationSeconds) }}</td>
                      <td class="py-2 text-gray-600 dark:text-gray-300">{{ decimal(agente.csatAverage) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          } @else {
            <p class="text-sm text-gray-400">Ningún agente atendió conversaciones en este periodo.</p>
          }
        </section>
      </div>
      }
    }

    <!-- CSAT: estado de la encuesta + resultados del periodo. -->
    @if (activeTab === 'csat') {
      @if (loadingCsat) {
        <p class="py-8 text-center text-sm text-gray-400">Cargando CSAT…</p>
      } @else if (csatError) {
        <div class="rounded-xl border border-dashed border-gray-200 py-10 text-center dark:border-gray-700">
          <p class="text-sm text-gray-500 dark:text-gray-400">{{ csatError }}</p>
        </div>
      } @else {
      <div class="space-y-7" data-test="panel-csat">

        <!-- ══ Estado de la encuesta ═════════════════════════════════════════ -->
        <section>
          <div class="mb-3 flex flex-wrap items-center gap-2">
            <h3 class="text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              Encuesta de satisfacción
            </h3>
            <app-badge [color]="csatActivo ? 'success' : 'light'">
              {{ csatActivo ? 'Activa' : 'Desactivada' }}
            </app-badge>
          </div>
          <dl class="grid grid-cols-1 gap-4 sm:grid-cols-2">
            <div>
              <dt class="text-xs text-gray-500 dark:text-gray-400">Escala</dt>
              <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ csatEscala }}</dd>
            </div>
            <div>
              <dt class="text-xs text-gray-500 dark:text-gray-400">Cuándo se pregunta</dt>
              <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ csatDisparador }}</dd>
            </div>
            <div class="sm:col-span-2">
              <dt class="text-xs text-gray-500 dark:text-gray-400">Pregunta</dt>
              <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">{{ csatPregunta }}</dd>
            </div>
            <div>
              <dt class="text-xs text-gray-500 dark:text-gray-400">Comentario del visitante</dt>
              <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">
                {{ csatConfig?.commentEnabled ? 'Habilitado' : 'Deshabilitado' }}
              </dd>
            </div>
            <div>
              <dt class="text-xs text-gray-500 dark:text-gray-400">Umbral de valoración negativa</dt>
              <dd class="mt-0.5 text-sm text-gray-800 dark:text-gray-200">
                {{ csatUmbralNegativo }}
              </dd>
            </div>
          </dl>
          @if (!csatActivo) {
            <p class="mt-3 text-xs text-gray-400">
              Con la encuesta desactivada no se piden nuevas valoraciones; los resultados de abajo son los ya recibidos.
            </p>
          }
        </section>

        <!-- ══ Resultados ════════════════════════════════════════════════════ -->
        <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
          <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
            Resultados <span class="font-normal normal-case tracking-normal text-gray-400">· últimos 30 días</span>
          </h3>
          @if (hayRespuestasCsat && csatMetrics) {
            <dl class="grid grid-cols-2 gap-4 sm:grid-cols-4">
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Valoración media</dt>
                <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ csatPromedio }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Respuestas</dt>
                <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ csatMetrics.totalResponses }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Tasa de respuesta</dt>
                <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ porcentaje(csatMetrics.responseRate) }}</dd>
              </div>
              <div>
                <dt class="text-xs text-gray-500 dark:text-gray-400">Negativas</dt>
                <dd class="mt-0.5 text-lg font-semibold text-gray-800 dark:text-gray-100">{{ csatMetrics.negativeCount }}</dd>
              </div>
            </dl>

            <div class="mt-4 flex flex-wrap gap-2">
              <span class="rounded-full bg-success-50 px-3 py-1 text-xs font-medium text-success-700 dark:bg-success-500/10 dark:text-success-400">
                Positivas: {{ csatMetrics.positiveCount }}
              </span>
              <span class="rounded-full bg-gray-100 px-3 py-1 text-xs font-medium text-gray-600 dark:bg-gray-800 dark:text-gray-300">
                Neutras: {{ csatMetrics.neutralCount }}
              </span>
              <span class="rounded-full bg-error-50 px-3 py-1 text-xs font-medium text-error-700 dark:bg-error-500/10 dark:text-error-400">
                Negativas: {{ csatMetrics.negativeCount }}
              </span>
            </div>
          } @else {
            <p class="text-sm text-gray-400">Todavía no hay respuestas de CSAT en este periodo.</p>
          }
        </section>

        <!-- ══ Distribución de puntuaciones ══════════════════════════════════ -->
        @if (distribucionCsat.length > 0) {
          <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
            <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              Distribución de puntuaciones
            </h3>
            <ul class="space-y-2">
              @for (fila of distribucionCsat; track fila.rating) {
                <li class="flex items-center gap-3">
                  <span class="w-6 shrink-0 text-right text-xs font-medium text-gray-600 dark:text-gray-300">{{ fila.rating }}</span>
                  <div class="h-2 flex-1 overflow-hidden rounded-full bg-gray-100 dark:bg-gray-800">
                    <div class="h-full rounded-full bg-brand-500" [style.width]="anchoBarraCsat(fila.count)"></div>
                  </div>
                  <span class="w-10 shrink-0 text-xs text-gray-500 dark:text-gray-400">{{ fila.count }}</span>
                </li>
              }
            </ul>
          </section>
        }

        <!-- ══ Comentarios recientes ═════════════════════════════════════════ -->
        @if (csatMetrics?.recentComments?.length) {
          <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
            <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              Comentarios recientes
            </h3>
            <ul class="space-y-3">
              @for (comentario of csatMetrics!.recentComments; track comentario.conversationId) {
                <li class="rounded-xl border border-gray-200 p-3 dark:border-gray-800">
                  <div class="flex flex-wrap items-center justify-between gap-2">
                    <span class="text-sm font-medium text-gray-800 dark:text-gray-100">Puntuación {{ comentario.rating }}</span>
                    <span class="text-xs text-gray-400">{{ comentario.submittedAt | date:'dd/MM/yyyy HH:mm' }}</span>
                  </div>
                  <p class="mt-1 whitespace-pre-line text-sm text-gray-600 dark:text-gray-300">{{ comentario.comment }}</p>
                </li>
              }
            </ul>
          </section>
        }

        <!-- ══ CSAT por agente ═══════════════════════════════════════════════ -->
        @if (csatMetrics?.byAgent?.length) {
          <section class="border-t border-gray-100 pt-6 dark:border-gray-800">
            <h3 class="mb-3 text-sm font-semibold uppercase tracking-wide text-gray-500 dark:text-gray-400">
              Por agente
            </h3>
            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-gray-200 text-left text-xs text-gray-500 dark:border-gray-700 dark:text-gray-400">
                    <th class="pb-2 pr-4 font-medium">Agente</th>
                    <th class="pb-2 pr-4 font-medium">Respuestas</th>
                    <th class="pb-2 font-medium">Media</th>
                  </tr>
                </thead>
                <tbody>
                  @for (fila of csatMetrics!.byAgent; track fila.userId) {
                    <tr class="border-b border-gray-100 last:border-0 dark:border-gray-800">
                      <td class="py-2 pr-4 text-gray-800 dark:text-gray-200">{{ fila.userName }}</td>
                      <td class="py-2 pr-4 text-gray-600 dark:text-gray-300">{{ fila.count }}</td>
                      <td class="py-2 text-gray-600 dark:text-gray-300">{{ decimal(fila.average) }}</td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </section>
        }
      </div>
      }
    }

    <!-- Historial de versiones: una fila por publicacion. -->
    @if (activeTab === 'versiones') {
      @if (loadingHistory) {
        <p class="py-8 text-center text-sm text-gray-400">Cargando historial...</p>
      } @else if (versions.length === 0) {
        <div class="rounded-xl border border-dashed border-gray-200 py-10 text-center dark:border-gray-700">
          <p class="text-sm text-gray-500 dark:text-gray-400">Este chatflow todavía no se ha publicado.</p>
          <p class="mt-1 text-xs text-gray-400">Cada publicación queda registrada aquí con su contenido y su autor.</p>
        </div>
      } @else {
        <ol class="space-y-3" data-test="lista-versiones">
          @for (version of versions; track version.id; let primera = $first) {
            <li class="flex gap-4 rounded-xl border border-gray-200 p-4 dark:border-gray-800">
              <div class="shrink-0">
                <span class="inline-flex h-9 min-w-9 items-center justify-center rounded-lg px-2 text-sm font-semibold"
                  [class.bg-brand-50]="primera" [class.text-brand-600]="primera"
                  [class.dark:bg-brand-500/10]="primera" [class.dark:text-brand-400]="primera"
                  [class.bg-gray-100]="!primera" [class.text-gray-500]="!primera"
                  [class.dark:bg-gray-800]="!primera" [class.dark:text-gray-400]="!primera">
                  v{{ version.versionNumber }}
                </span>
              </div>
              <div class="min-w-0 flex-1">
                <div class="flex flex-wrap items-center gap-2">
                  <span class="text-sm font-medium text-gray-800 dark:text-gray-100">
                    {{ version.publishedAt | date:'dd/MM/yyyy HH:mm' }}
                  </span>
                  @if (primera) {
                    <span class="rounded-full bg-success-50 px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wide text-success-700 dark:bg-success-500/10 dark:text-success-400">
                      Actual
                    </span>
                  }
                </div>
                <p class="mt-0.5 text-sm text-gray-600 dark:text-gray-300">{{ version.changeSummary }}</p>
                <p class="mt-1 text-xs text-gray-400">
                  Publicado por {{ version.publishedByName || 'un usuario que ya no existe' }}
                </p>
              </div>
              <!-- La version actual no se restaura sobre si misma. -->
              @if (!primera) {
                <div class="shrink-0 self-center">
                  <button type="button" (click)="restaurarVersion(version)"
                    [disabled]="restaurandoVersionId !== null" data-test="restaurar-version"
                    class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-semibold text-gray-700 transition hover:bg-gray-50 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
                    {{ restaurandoVersionId === version.id ? 'Restaurando...' : 'Restaurar' }}
                  </button>
                </div>
              }
            </li>
          }
        </ol>
      }
    }

    <!-- Comentarios: notas internas del equipo. -->
    @if (activeTab === 'comentarios') {
      <div class="space-y-4">
        <div>
          <textarea rows="3" [(ngModel)]="nuevoComentario" data-test="nuevo-comentario"
            placeholder="Deja una nota para el equipo sobre este chatflow..."
            class="w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 placeholder-gray-400 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white"></textarea>
          <div class="mt-2 flex justify-end">
            <button type="button" (click)="agregarComentario()"
              [disabled]="!nuevoComentario.trim() || guardandoComentario" data-test="publicar-comentario"
              class="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600 disabled:cursor-not-allowed disabled:opacity-50">
              {{ guardandoComentario ? 'Publicando...' : 'Comentar' }}
            </button>
          </div>
        </div>

        @if (loadingHistory) {
          <p class="py-6 text-center text-sm text-gray-400">Cargando comentarios...</p>
        } @else if (comments.length === 0) {
          <div class="rounded-xl border border-dashed border-gray-200 py-10 text-center dark:border-gray-700">
            <p class="text-sm text-gray-500 dark:text-gray-400">Todavía no hay comentarios.</p>
            <p class="mt-1 text-xs text-gray-400">Úsalos para dejar contexto al resto del equipo.</p>
          </div>
        } @else {
          <ul class="space-y-3" data-test="lista-comentarios">
            @for (comentario of comments; track comentario.id) {
              <li class="rounded-xl border border-gray-200 p-4 dark:border-gray-800">
                <div class="flex flex-wrap items-center justify-between gap-2">
                  <span class="text-sm font-medium text-gray-800 dark:text-gray-100">
                    {{ comentario.createdByName || 'Usuario eliminado' }}
                  </span>
                  <span class="text-xs text-gray-400">
                    {{ comentario.datetimeCreated | date:'dd/MM/yyyy HH:mm' }}
                    @if (comentario.datetimeUpdated !== comentario.datetimeCreated) { &middot; editado }
                  </span>
                </div>

                @if (comentarioEnEdicion?.id === comentario.id) {
                  <textarea rows="3" [(ngModel)]="comentarioEnEdicion!.texto" data-test="editar-comentario"
                    class="mt-2 w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-sm text-gray-800 focus:border-brand-500 focus:outline-none dark:border-gray-700 dark:bg-gray-800 dark:text-white"></textarea>
                  <div class="mt-2 flex justify-end gap-2">
                    <button type="button" (click)="cancelarEdicion()"
                      class="rounded-lg border border-gray-300 px-3 py-1.5 text-xs font-medium text-gray-700 dark:border-gray-700 dark:text-gray-300">
                      Cancelar
                    </button>
                    <button type="button" (click)="guardarEdicion()" [disabled]="!comentarioEnEdicion!.texto.trim()"
                      class="rounded-lg bg-brand-500 px-3 py-1.5 text-xs font-semibold text-white disabled:opacity-50">
                      Guardar
                    </button>
                  </div>
                } @else {
                  <p class="mt-1.5 whitespace-pre-line text-sm text-gray-600 dark:text-gray-300">{{ comentario.contentText }}</p>
                  <!-- Editar/eliminar solo para el autor: lo decide el backend y aqui solo se refleja. -->
                  @if (comentario.ownedByCurrentUser) {
                    <div class="mt-2 flex gap-3">
                      <button type="button" (click)="empezarEdicion(comentario)"
                        class="text-xs font-medium text-brand-600 hover:underline dark:text-brand-400">Editar</button>
                      <button type="button" (click)="eliminarComentario(comentario)"
                        class="text-xs font-medium text-error-600 hover:underline dark:text-error-400">Eliminar</button>
                    </div>
                  }
                }
              </li>
            }
          </ul>
        }
      </div>
    }

    <!-- ══ Acciones ══════════════════════════════════════════════════════ -->
    <div class="mt-8 flex flex-wrap justify-end gap-3 border-t border-gray-100 pt-6 dark:border-gray-800">
      <button type="button" (click)="onClose()"
        class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Cerrar
      </button>
      <button type="button" (click)="irAEditor('analitica')"
        class="rounded-lg border border-gray-300 px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 dark:border-gray-700 dark:text-gray-300 dark:hover:bg-gray-800">
        Ver analítica
      </button>
      <button type="button" (click)="irAEditor('general')"
        class="rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white transition-colors hover:bg-brand-600">
        Editar
      </button>
    </div>
  </div>
  }
</app-modal>
